import Cookies from 'universal-cookie';

/**
 * @description new Cookies
 */
const instance = new Cookies();

/**
 * @description clear all cookies
 */
const clear = () => {
  const cookies = instance.getAll();
  for (const key in cookies) {
    instance.remove(key);
  }
};

export default {
  instance,
  clear
};
